import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { stringify } from 'query-string';
import { buildQueryKey } from '../../../helpers';
import { SORT, SORTBY } from '../constants';
const updateSort = (value, query, url, hashBit = '', listComponentName = '') => {
  const sortKey = buildQueryKey(SORT, listComponentName);
  const sortByKey = buildQueryKey(SORTBY, listComponentName);
  const [newSortBy, newSort] = value.split(':');
  const updatedQuery = _objectSpread(_objectSpread({}, query), {}, {
    [sortByKey]: newSortBy,
    [sortKey]: newSort
  });
  const parsedQuery = stringify(updatedQuery);
  return `${url}?${parsedQuery}${hashBit}`;
};
export default updateSort;
//# sourceMappingURL=update-sort.js.map